import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import DataTable from 'react-data-table-component';
import { LuLogs } from "react-icons/lu";
import Select from 'react-select';
import styles from "./auditlog.module.css";
import { api } from '../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../utils/layout/windowsLayout';



export default function AuditLog(props) {
    const { windowSize, setMenuActual } = useAuth();
    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(50);
    const [userSelect, setUserSelect] = useState([]);
    const [users, setUsers] = useState([]);

    const columns = [
        {
            name: 'Usuario',
            selector: row => row.userName,
            flex: "1",
            sortable: true,
            width: '300px',
        },
        {
            name: 'Fecha y Hora',
            selector: row => row.date ? row.date.replace("T", " ") : "",
            flex: "1",
            width: "200px"
        },
        {
            name: 'Modulo',
            selector: row => row.module,
            flex: "1",
            width: "200px"
        },
        {
            name: 'Acción',
            selector: row => row.action,
            flex: "1",
            width: "300px",
            wrap: true,
        },
        {
            name: 'Descripción',
            selector: row => row.description,
            flex: "1",
        }
    ];

    const handleGetUsers = () => {
        api(SERVICE.getUser)
            .then((data) => {
                let arrayTemp = [];
                
                console.log(data.data.data)
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.firstName + " " + element.lastName,

                        });

                    }
                }
                setUsers(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdate = () => {
        let filterByUserId = "";
        if (userSelect != 0 && userSelect != null) {
            filterByUserId = "&userId=" + userSelect.value;
        }
        api(SERVICE.getAuditLog + `?TypeSearch=1&Page=${page}&PageSize=${perPage}${filterByUserId}`)
            .then((data) => {
                let arrayTemp = [];
                if (data && data.data && data.data.paginationInfo) {
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    setDataTable(data.data.data);
                } else {
                    setDataTable([]);
                }

            })
            .catch((err) => {
                console.log(err);
                setDataTable([]);
            })
    }

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        handleUpdate();
    }, [page, perPage, userSelect])
    useEffect(() => {
        handleGetUsers();
    }, [])
    return (
        <>
            <WindowLayout
                title="Log de Auditoria"
                route={["Inicio", "Log de Auditoria",]}
                actions={[() => setMenuActual("homeMenu")]}
                icon={<LuLogs />}
            >
                <div className='paperContainer'>
                    <div style={{ display: "flex", justifyContent: "left", alignItems: "center", flexWrap: "wrap" }}>
                        <div className={styles.itemForm} style={{ zIndex: 7 }}>
                            <label class="form-label">Usuarios: </label>
                            <Select isClearable options={users} class="form-control" placeholder="Usuarios" value={userSelect} onChange={(e) => setUserSelect(e)} />
                        </div>

                    </div>

                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[50, 70, 90, 100]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>

        </>
    );
} 